import { TableParameters } from 'app/component-library/table/table-parameters';
import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';
import { RunnableLookupCopyState } from './../../shared/enums/runnable-lookup-copy-state';
import { RunnableLookupBriefInfo } from './runnable-lookup-brief-info';
import { RunnableLookupSaveDataRow } from './runnable-lookup-save-data-row';
import { RunnableLookupColumn } from './runnableLookup-column';

export class RunnableLookupSaveData implements ViewModel{
  friendlyTypeNameSingular: string = 'RunnableLookupSaveData';
  apiRoute: string = CONFIG.apiRoutes.runnableLookupsSave;

  public briefInfo: RunnableLookupBriefInfo;
  public columns: RunnableLookupColumn[] = [];
  public rows: RunnableLookupSaveDataRow[] = [];

  public attributesTableParameters: TableParameters;
  public valuesTableParameters: TableParameters;

  public totalColumnsCount: number = 0;
  public totalRowsCount: number = 0;

  public copyState: RunnableLookupCopyState = RunnableLookupCopyState.NoCopy;

  json() {
    return this;
  }
  loadFromJson(data: any) {
    if(data.briefInfo){
      this.briefInfo = new RunnableLookupBriefInfo();
      this.briefInfo.loadFromJson(data.briefInfo);
    }

    if(data.columns){
      for (const column of data.columns){
        const newColumn = new RunnableLookupColumn();
        newColumn.loadFromJson(column);
        this.columns.push(newColumn);
      }
    }

    if(data.rows){
      for (const row of data.rows) {
        const newRow = new RunnableLookupSaveDataRow();
        newRow.loadFromJson(row);
        this.rows.push(newRow);
      }
    }

    this.totalColumnsCount = data.totalColumnsCount;
    this.totalRowsCount = data.totalRowsCount;

  }
}
